import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CiqEventsEffects } from './ciq-events.effects';

// @dynamic
@NgModule({
  imports: [EffectsModule.forFeature([CiqEventsEffects])]
})
export class CiqEventsLazyModule {}
